import { createSelector } from 'reselect'
import { getCurrentModeId } from 'tickets/redux/modules/router/selectors'
import { getIsDropOff } from 'tickets/redux/modules/searchParams/selectors'

const getFilters = state => state.filters

const getActiveFilters = createSelector(
  [getCurrentModeId, getFilters],
  (activeModeId, filters) => filters[activeModeId]
)

const getActiveOutboundHour = createSelector(
  [getActiveFilters],
  filters => filters && filters.outboundDepartureTime
)

const getActiveInboundHour = createSelector(
  [getActiveFilters],
  filters => filters && filters.inboundDepartureTime
)

const getActiveFerryType = createSelector(
  [getActiveFilters],
  filters => filters && filters.ferryType
)

const getActiveOriginLongName = createSelector(
  [getActiveFilters],
  filters => filters && filters.originLongName
)

const getActiveDestinationLongName = createSelector(
  [getActiveFilters],
  filters => filters && filters.destinationLongName
)

const getActiveOriginGooglePlaceId = createSelector(
  [getActiveFilters],
  filters => filters && filters.originGooglePlaceId
)

const getActiveDestinationGooglePlaceId = createSelector(
  [getActiveFilters],
  filters => filters && filters.destinationGooglePlaceId
)

const getIsActiveModeLocked = createSelector(
  [getActiveFilters],
  filters => filters && filters.updatedInformation
)

const getDepatureDateTime = createSelector(
  [getActiveFilters],
  (filters) => filters && filters.departureDateTime
)

const getReturnDateTime = createSelector(
  [getActiveFilters],
  (filters) => filters && filters.returnDateTime
)

const getGooglePlaceId = createSelector(
  [
    getActiveOriginGooglePlaceId,
    getActiveDestinationGooglePlaceId,
    getIsDropOff,
  ],
  (
    originGooglePlaceId,
    destinationGooglePlaceId,
    isDropOff
  ) => (isDropOff ? destinationGooglePlaceId : originGooglePlaceId)
)

// Get long name of transfer if valid googlePlaceID
const getTransferLongName = createSelector(
  [getGooglePlaceId, getActiveOriginLongName, getActiveDestinationLongName, getIsDropOff],
  (googlePlaceId, originLongName, destinationLongName, isDropOff) => {
    if (!googlePlaceId) {
      return ''
    }
    return isDropOff ? destinationLongName : originLongName
  }
)

export {
  getFilters,
  getActiveFilters,
  getActiveOutboundHour,
  getActiveInboundHour,
  getActiveFerryType,
  getGooglePlaceId,
  getTransferLongName,
  getIsActiveModeLocked,
  getDepatureDateTime,
  getReturnDateTime,
}
